import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Title from '../Title/Title'
import Products from "../../components/Products";

import { fetchTrendingProd } from "../../apiCalls/product";

const TrendingProducts = () => {
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.products.trendingProducts);

  console.log(productList, 'trend lsdfjhdfb')

  useEffect(() => {
    fetchTrendingProd(dispatch);
  }, [dispatch]);


  return (
    <>
        <section className='new-products'>
            <Title title="Trending Products" />
                    <Products products={productList} />
        </section>
    </>
  )
}

export default TrendingProducts